import cl from 'clsx';
import { ReactNode } from 'react';

import { ChildrenProps, ClassNameProps } from '@/true-fsd/shared/utils/react';

import { Checkbox2 } from './Checkbox2';
import classes from './Checkbox2Radio.module.scss';

type Checkbox2RadioRenderProps = {
  RenderContainer: (props: ChildrenProps & ClassNameProps) => ReactNode;
  RenderLabel: (
    props: ChildrenProps & ClassNameProps & { checkboxNode: ReactNode },
  ) => ReactNode;
};

const DefaultRenderContainer: Checkbox2RadioRenderProps['RenderContainer'] = ({
  children,
  className,
}) => <div className={cl(classes.defaultContainer, className)}>{children}</div>;

const DefaultRenderLabel: Checkbox2RadioRenderProps['RenderLabel'] = ({
  checkboxNode,
  children,
  className,
}) => (
  <label className={cl(classes.defaultLabel, className)}>
    {checkboxNode}
    {children}
  </label>
);

export type Checkbox2RadioProps<Value extends string> = {
  options: {
    value: Value;
    label: ReactNode;
  }[];

  value: Value;
  onChange: (v: Value) => void;
} & Partial<Checkbox2RadioRenderProps> &
  ClassNameProps;
export const Checkbox2Radio = <Value extends string>({
  options,
  RenderContainer = DefaultRenderContainer,
  RenderLabel = DefaultRenderLabel,
  className,
  value,
  onChange,
}: Checkbox2RadioProps<Value>) => {
  const onCheckedChange = (optValue: Value) => (v: boolean) => {
    if (v) {
      onChange(optValue);
    }
  };

  return (
    <RenderContainer className={className}>
      {options.map((opt) => (
        <RenderLabel
          key={opt.value}
          checkboxNode={
            <Checkbox2
              size="large"
              checked={value === opt.value}
              onCheckedChange={onCheckedChange(opt.value)}
            />
          }
        >
          {opt.label}
        </RenderLabel>
      ))}
    </RenderContainer>
  );
};
